module.exports = __webpack_public_path__ + "static/media/dot.193f6331.svg";